// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderReviewCard-paymentReviewCard-RYXP1 {
    padding: 42px 24px;
    background: var(--background-primary);
    border-radius: var(--radius-3);
    text-align: center;
}

.ProviderReviewCard-paymentReviewCardImgContainer-lWdwc {
    position: relative;
    width: 165px;
    height: 165px;
    margin: 0 auto;
    border-radius: var(--radius-3);
}

.ProviderReviewCard-paymentReviewCardImgContainer-lWdwc img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    border-radius: inherit;
}

.ProviderReviewCard-paymentReviewCardInfo-MsPWP {
    margin-top: 18px;
}

.ProviderReviewCard-paymentReviewCardInfoHeading-AznQ6 {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
}

.ProviderReviewCard-paymentReviewStarContainer-_Ovi9 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 6px;
}

@media (max-width: 767px) {
    .ProviderReviewCard-paymentReviewCard-RYXP1 {
        padding: 24px 18px;
    }

    .ProviderReviewCard-paymentReviewCardImgContainer-lWdwc {
        width: 135px;
        height: 135px;
    }

    .ProviderReviewCard-paymentReviewCardInfoHeading-AznQ6 {
        font-size: 18px;
        line-height: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ProviderReviewCard/ProviderReviewCard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".paymentReviewCard {\n    padding: 42px 24px;\n    background: var(--background-primary);\n    border-radius: var(--radius-3);\n    text-align: center;\n}\n\n.paymentReviewCardImgContainer {\n    position: relative;\n    width: 165px;\n    height: 165px;\n    margin: 0 auto;\n    border-radius: var(--radius-3);\n}\n\n.paymentReviewCardImgContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n}\n\n.paymentReviewCardInfo {\n    margin-top: 18px;\n}\n\n.paymentReviewCardInfoHeading {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 30px;\n}\n\n.paymentReviewStarContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n@media (max-width: 767px) {\n    .paymentReviewCard {\n        padding: 24px 18px;\n    }\n\n    .paymentReviewCardImgContainer {\n        width: 135px;\n        height: 135px;\n    }\n\n    .paymentReviewCardInfoHeading {\n        font-size: 18px;\n        line-height: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentReviewCard": `ProviderReviewCard-paymentReviewCard-RYXP1`,
	"paymentReviewCardImgContainer": `ProviderReviewCard-paymentReviewCardImgContainer-lWdwc`,
	"paymentReviewCardInfo": `ProviderReviewCard-paymentReviewCardInfo-MsPWP`,
	"paymentReviewCardInfoHeading": `ProviderReviewCard-paymentReviewCardInfoHeading-AznQ6`,
	"paymentReviewStarContainer": `ProviderReviewCard-paymentReviewStarContainer-_Ovi9`
};
module.exports = ___CSS_LOADER_EXPORT___;
